export default "__VITE_ASSET__5e2502d5__"